"use client";

import { create } from "zustand";

interface SessionState {
  sessionExpired: boolean;
  setSessionExpired: (expired: boolean) => void;
  clearSessionExpired: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
    sessionExpired: 
    typeof window !== "undefined" 
      ? sessionStorage.getItem("session_expired") === "true" 
      : false,
  
  setSessionExpired: (expired) => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem("session_expired", String(expired));
    }
    set({ sessionExpired: expired });
  },
  
  clearSessionExpired: () => {
    if (typeof window !== "undefined") {
      sessionStorage.removeItem("session_expired");
    }
    set({ sessionExpired: false });
  },
}));